/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderExportRowDTOFromJSON, OrderExportRowDTOToJSON, } from './OrderExportRowDTO';
/**
 * Check if a given object implements the OrderExportResponseDTO interface.
 */
export function instanceOfOrderExportResponseDTO(value) {
    return true;
}
export function OrderExportResponseDTOFromJSON(json) {
    return OrderExportResponseDTOFromJSONTyped(json, false);
}
export function OrderExportResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'rows': json['rows'] == null ? undefined : (json['rows'].map(OrderExportRowDTOFromJSON)),
        'truncated': json['truncated'] == null ? undefined : json['truncated'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'matchedOrderCount': json['matchedOrderCount'] == null ? undefined : json['matchedOrderCount'],
    };
}
export function OrderExportResponseDTOToJSON(json) {
    return OrderExportResponseDTOToJSONTyped(json, false);
}
export function OrderExportResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'rows': value['rows'] == null ? undefined : (value['rows'].map(OrderExportRowDTOToJSON)),
        'truncated': value['truncated'],
        'limit': value['limit'],
        'matchedOrderCount': value['matchedOrderCount'],
    };
}
